<template>
  <div class="page">
    <div class="topBg">
      <Header theme="white"></Header>
      <div class="pageText">
        <div class="pageName">二级节点</div>
        <div class="pageEnglish">/ Secondary node</div>
      </div>
    </div>
    <div style="background-color: #F5F7FC;padding-bottom: 60px;">
      <div class="pageContent">
        <div class="dls">代理商</div>
        <swiper class="yyOutWrap" :options="swiperOption2" v-if="dlsList.length">
          <swiper-slide v-for="(item, index) in dlsList" :key="index+1">
            <div class="dlsList">
              <img :src="baseUrl + item.logo" style="height: 60%;" >
              <!-- <div :class="[code == index ? 'active01': '']"></div> -->
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="tabContent">
        <div v-if="code === index" class="list" v-for="(item, index) in dlsList" :key="index">
          <div class="title">{{item.agentName}}</div>
          <div class="text">{{item.introduce}}</div>
          <div>
            <div class="bt">
              二级节点
            </div>
            <div class="imgs">
              <img v-for="(a, b) in imgs" :key="b" class="jwl" :src="baseUrl + a.logo" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="nodeTab">
        二级节点
      </div>
      <div class="tabContent">
        <div class="text">{{AnalysisData[0].contentTitle}}</div>
        <img class="jdImg" :src="baseUrl + AnalysisData[0].image" alt="" srcset="">
      </div>
    </div>
    <Contact />
    <Footer />
  </div>
</template>

<script>
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  import "swiper/swiper-bundle.css";
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    fetchIntroduceByType,
    nodeAgentList,
    nodeEjjdList,
    contentByType
  } from '@/api/api.js'
  import Contact from './Contact.vue'
  export default {
    data() {
      const _self = this;
      return {
        swiperOption2: {
          // 可见图片张数
          slidesPerView: 3,
          // 默认选中中间一张
          centeredSlides: false,
          centeredSlidesBounds: true,
          // 无限循环
          loop: true,
          // effect: 'coverflow',
          // 小圆点（我此处没使用，列出供参考）
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          coverflow: {
            rotate: 0, // slide做3d旋转时Y轴的旋转角度。默认50。
            stretch: 200, // 每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
            depth: 150, // slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
            // modifier: 1, // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
            slideShadows: false // 开启slide阴影。默认 true。
          },
          // 自动轮播
          autoplay: {
            stopOnLastSlide: true,
            delay: 3000
          },
          autoplay: { disableOnInteraction: false },
          // 上下按钮点击轮播效果
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          on: {
            slideChangeTransitionStart: function(){
              _self.code = this.realIndex

            }
          },
        },
        imgs: [],
        baseUrl: serverUrl.baseURL,
        AnalysisData: [],
        initialIndex: 0,
        list: [],
        code: 0,
        dlsList: [],
        active: 0,
        tabList: [{
          name: '节点介绍'
        }],
        tabData: null,
        systemList: [{
          with: 33,
          height: 33,
          img: require("../../assets/images/icon_tx@2x.png"),
          img1: require("../../assets/images/tx2@2x.png"),
          title: '全省监测',
          content: '体系架构内容包括标识解析流程，标识注册流程，省内、全国节点分布情况。',
          img2: require("../../assets/images/icon_tx3@2x.png"),
          with1: 117,
          height1: 127,
          path: '/NodePage'
        }, {
          with: 36,
          height: 34,
          img: require("../../assets/images/icon_sj@2x.png"),
          img1: require("../../assets/images/icon_sj2@2x.png"),
          title: '建设指导',
          content: '数据监测从企业维度、行业维度、 区域维度对节点标识注册量和解析 量进行统计。',
          img2: require("../../assets/images/icon_sj3@2x.png"),
          with1: 115,
          height1: 134,
          path: '/Guidance'
        }, {
          with: 43,
          height: 33,
          img: require("../../assets/images/icon_fwq@2x.png"),
          img1: require("../../assets/images/icon_fwq2@2x.png"),
          title: '建设咨询',
          content: '服务监测主要监听服务器实时运行 情况，监听项包括CPU，内存，磁 盘，端口。',
          img2: require("../../assets/images/icon_fwq3@2x.png"),
          with1: 123,
          height1: 99,
          path: '/build'
        }, {
          with: 27,
          height: 33,
          img: require("../../assets/images/icon-aq@2x.png"),
          img1: require("../../assets/images/icon-aq2@2x.png"),
          title: '运营管理',
          content: '安全监测是对支撑二级节点运行的 各个子服务的监测。',
          img2: require("../../assets/images/icon-aq3@2x.png"),
          with1: 113,
          height1: 126,
          path: '/operation'
        }],
        ceshi: {},
        timer: null
      }
    },
    watch: {
      code: {
        handler(newValue, oldValue){
          nodeEjjdList({id: this.dlsList[newValue].id}).then(res=> {
            this.imgs = res.data
          })
        },
        immediate: true
      }
    },
    components: {
      Header,
      Footer,
      Contact,
      swiper,
      swiperSlide,
    },
    mounted() {
      this.getTabData()
      this.getNodeAgentList()
      this.getAnalysis()
    },
    methods: {
      getNodeAgentList() {
        nodeAgentList().then(res => {
          this.dlsList = res.data
          nodeEjjdList({id: this.dlsList[0].id}).then(res=> {
            this.imgs = res.data
          })
          if(res.data.length <= 2) {
            this.swiperOption2.slidesPerView = res.data.length
            if(res.data.length == 1) {
              this.swiperOption2.loop = false
              this.swiperOption2.autoplay.stopOnLastSlide = false
            }
          }else{
            this.swiperOption2.slidesPerView = 3
          }
        })
      },
      getAnalysis() {
        let params = {
          type: 2
        }
        contentByType(params).then(res => {
          this.AnalysisData = res.data
        })
      },
      goHome(num) {
        if (num === 1) {
          this.$router.push({
            path: '/Home'
          })
        } else if (num === 2) {
          this.$router.push({
            path: '/Home',
            query: {
              id: 'node'
            }
          })
        }
      },
      goNodePage() {
        this.$router.push({
          path: '/NodePage'
        })
      },
      goGuidance() {
        this.$router.push({
          path: '/Guidance'
        })
      },
      goBuild() {
        this.$router.push({
          path: '/build'
        })
      },
      goOperation() {
        this.$router.push({
          path: '/operation'
        })
      },
      goPage(path) {
        this.$router.push({
          path: path
        })
      },
      tabChange(index) {
        this.active = index
        this.getTabData()
      },
      getTabData() {
        let params = {}
        // type: 1二级节点介绍 2建设指导 3建设咨询 4运营管理 5企业节点介绍 6企业上节点 7节点建设
        if (this.active === 0) {
          params.type = 1
        } else if (this.active === 1) {
          params.type = 7
        }
        fetchIntroduceByType(params).then(res => {
          this.tabData = res.data
        })
      }
    }
  }
</script>

<style scoped>
  .crumbs {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
    padding: 50px 0 30px 0px;
    margin-top: 108px;
  }

  .crumbs span {
    cursor: pointer;
  }

  .curLink {
    color: rgba(18, 30, 48, 1);
  }

  .container {
    width: 1400px;
    background: #fff;
    /* border: 1px solid #f00; */
    margin: 0 auto 40px;
  }

  .topBar {
    padding: 21px 28px;
    background: linear-gradient(90deg, #E9EFFF, #FFFFFF);
    border-radius: 10px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #121E30;
  }

  .nodeMsg {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 30px 40px 0;
  }

  .nodeLogoBox {
    width: 152px;
    height: 152px;
    background: rgba(15, 94, 255, 1);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 100px;
  }

  .nodeLogo {
    width: 108px;
    height: 102px;
  }

  .nodeIntroduction {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    line-height: 20px;
    width: 85%;
  }

  .nodeIntroduction .label {
    color: rgba(144, 157, 177, 1);
  }

  .myCol1 {
    padding: 15px 0;
    display: flex;
    align-items: flex-start;
  }

  .myCol1 div {
    display: block;
    width: 80%;
    line-height: 26px;
  }

  .myCol1 .label {
    padding-top: 20px;
  }

  .myCol1 div p {
    text-indent: 2em;
  }

  .myCol3 {
    display: flex;
    align-items: center;
    padding: 15px 0;
    ;
  }

  .myCol3>div {
    width: 30%;
  }

  .nodeTab {
    font-size: 46px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #121E30;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 50px 0 20px;
    text-align: center;
  }

  .nodeTab span {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 32px;
    color: #909DB1;
    padding: 0 20px;
    cursor: pointer;
    display: block;
    padding-bottom: 15px;
    border-bottom: 3px solid transparent;
  }

  .nodeTab .active {}

  .tabContent {
    padding: 20px 60px;
  }

  .tabContent .info {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    line-height: 32px;
  }

  .buildImg {
    width: 100%;
    height: 302px;
    margin-top: 30px;
  }

  .infoP {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    line-height: 32px;
  }

  .introduceImg {
    width: 638px;
    display: block;
    margin: 0 auto;
    height: 431px;
  }


  .systemList {
    width: 1272px;
    margin: 0 auto 30px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    /* align-items: center; */
  }

  .systemList>div {
    width: 318px;
    height: 181px;
    padding: 58px 25px 30px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
  }

  .systemList>div .content {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #8F99AB;
    line-height: 27px;
  }

  .systemList>div .title {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #1B222C;
    line-height: 24px;
    margin: 30px 0;
  }

  .systemList>div:nth-child(1) {
    background: #F8F8F8;
  }

  .systemList>div:nth-child(2) {
    background: #F1F1F1;
  }

  .systemList>div:nth-child(3) {
    background: #F8F8F8;
  }

  .systemList>div:nth-child(4) {
    background: #F1F1F1;
  }

  .systemList>div:hover {
    /* width: 318px; */
    /* height: 343px; */
    background: #0F5BE8;
    /* top: -30px */
  }

  .systemList>div .img2 {
    display: none;
  }

  .systemList>div:hover .img1 {
    display: none;
  }

  .systemList>div:hover .img2 {
    display: block;
  }

  .systemList>div:hover .content {
    color: #fff;
  }

  .systemList>div:hover .title {
    color: #fff;
  }

  .topBg {
    height: 479px;
    background: url('../../assets/images/jjfa1@2x.png') top center no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
  }

  .pageText {
    padding: 150px 200px 0;
  }

  .pageName {
    font-size: 46px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 70px;
  }

  .pageEnglish {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 70px;
  }

  .pageContent {
    padding: 44px 199px 0;
    background: #F5F7FC;
    margin-bottom: 20px;
  }

  .tabContent {
    margin: 0 250px;
    background: #fff;
  }

  .tabContent .title {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #121E30;
    line-height: 28px;
  }

  .tabContent .text {
    margin-top: 20px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #5E6A7C;
    line-height: 28px;
    padding-bottom: 20px;
    /* height: 95px; */
  }

  .dlsArr {
    display: flex;
    justify-content: flex-start;
    max-width: 1500px;
    overflow-y: scroll;
    margin: 50px 0;
  }

  .dlsArr::-webkit-scrollbar {
    display: none !important;
  }

  .dls {
    font-size: 46px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #121E30;
    text-align: center;
    margin: 20px 0;
  }

  .dlsList {
    width: 400px;
    height: 118px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    margin: 0 50px;
    position: relative;
    box-sizing: border-box;
    padding: 10px;
  }

  .dlsList>div {
    width: 100%;
    height: 2px;
    position: absolute;
    left: 0;
    bottom: 0px;
  }

  .active01 {
    background: #0F5EFF;
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    animation: appShow01 2s;
  }

  .active02 {
    background: #fff !important;
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: 0px;
    left: 0px;
  }

  @keyframes appShow01 {
    0% {
      width: 0%;
    }

    100% {
      width: 100%;
      background: #0F5EFF;
    }
  }

  .page {
    background: #fff;
  }

  .bt {
    width: 166px;
    height: 29px;
    margin: 30px 0;
    background: url('../../assets/images/bt@2x.png') left center no-repeat;
    background-size: 100% 100%;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #7188AE;
    text-align: center;
    line-height: 29px;
  }

  .imgs>img {
    margin: 10px 20px;
  }

  .jwl {
    /* width: 146px; */
    height: 48px;
  }

  .hcsw {
    width: 167px;
    height: 47px;
  }

  /deep/ .el-carousel__container {
    height: 200px;
  }

  /deep/ .el-carousel__indicators--horizontal {
    display: none;
  }

  .btn {
    width: 134px;
    height: 43px;
    background: #0F5EFF;
    border-radius: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 43px;
    text-align: center;
    margin: 30px 0;
    cursor: pointer;
  }

  .tabContent .text {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    line-height: 32px;
  }

  .tabContent .jdImg {
    width: 832px;
    height: 563px;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/node/SecondaryNode.vue